import { render, staticRenderFns } from "./TagDependencyList.vue?vue&type=template&id=e1556aae&scoped=true"
import script from "./TagDependencyList.vue?vue&type=script&setup=true&lang=js"
export * from "./TagDependencyList.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e1556aae",
  null
  
)

export default component.exports